import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
  HttpClient,
} from "@angular/common/http";
import { catchError, map, Observable, throwError } from "rxjs";
import { BindingURLService } from "../Bindingurlservice/binding-url.service";
import { ApiService } from "../apiUrls/apiUrl.service";

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {
  constructor(
    private httpC: HttpClient,
    private urlAuthentication: BindingURLService,
    private apiUrl: ApiService,
  ) {}
  token;
  private isLoggingOut = false;
  // intercept(
  //   req: HttpRequest<any>,
  //   next: HttpHandler
  // ): Observable<HttpEvent<any>> {
  //   this.token = sessionStorage.getItem("invUIToken");

  //   if (this.token) {
  //     const authReq = req.clone({
  //       setHeaders: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         Authorization: this.token,
  //       },
  //     });
  //     return next.handle(authReq).pipe(
  //       map((event: HttpEvent<any>) => {
  //         if (event instanceof HttpResponse) {
  //           event = event.clone({
  //             body: this.stringifyResponse(event.body),
  //           });
  //         }
  //         return event;
  //       }),
  //       catchError((error) => this.handleError(error))
  //     );
  //   }

  //   return next.handle(req);
  // }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    this.token = sessionStorage.getItem("invUIToken");

    const authReq = req.clone({
      withCredentials: true,
      setHeaders: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    return next.handle(authReq).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          event = event.clone({
            body: this.stringifyResponse(event.body),
          });
        }
        return event;
      }),
      catchError((error) => this.handleError(error)),
    );
  }

  private stringifyResponse(response: any): any {
    if (response.body) {
      const getResp: string = JSON.stringify(response.body);
      let resp = JSON.parse(getResp);

      return resp;
    }
    return response;
  }

  //Error Handling
  // private handleError(error: HttpErrorResponse): Observable<never> {
  //   let errorMessage = "An error occurred";
  //   if (error.error instanceof ErrorEvent) {
  //     errorMessage = error.error.message;
  //   } else {
  //     errorMessage = error.error || errorMessage;
  //   }
  //   // if (error.status == 401) {
  //   //   console.log("error.status", error.status);
  //   //   const reqEntity = {
  //   //     Token: this.token,
  //   //   };
  //   //   this.httpC
  //   //     .post(
  //   //       this.urlAuthentication.loginUrl + this.apiUrl.logoutUrl,
  //   //       reqEntity,
  //   //     )
  //   //     .subscribe((resp) => {
  //   //       localStorage.removeItem("invMonitoring");
  //   //       sessionStorage.clear();
  //   //     });
  //   //   sessionStorage.setItem("invUIToken", "");
  //   //   sessionStorage.setItem("user", "");
  //   //   window.open("#/login", "_self");
  //   // }
  //   if (error.status == 401 && !this.isLoggingOut) {
  //     this.isLoggingOut = true;
  //     this.httpC
  //       .post(this.urlAuthentication.loginUrl + this.apiUrl.logoutUrl, {})
  //       .subscribe({
  //         next: () => {
  //           localStorage.removeItem("invMonitoring");
  //           sessionStorage.clear();
  //         },
  //         error: () => {
  //           localStorage.removeItem("invMonitoring");
  //           sessionStorage.clear();
  //         },
  //       });
  //     sessionStorage.setItem("invUIToken", "");
  //     sessionStorage.setItem("user", "");
  //     window.open("#/login", "_self");
  //   }
  //   return throwError(errorMessage);
  // }

  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = "An error occurred";
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = error.error || errorMessage;
    }
    if (
      error.status == 401 &&
      !this.isLoggingOut &&
      sessionStorage.getItem("user")
    ) {
      this.isLoggingOut = true;
      this.httpC
        .post(this.urlAuthentication.loginUrl + this.apiUrl.logoutUrl, {})
        .subscribe({
          next: () => {
            localStorage.removeItem("invMonitoring");
            sessionStorage.clear();
            this.isLoggingOut = false;
          },
          error: () => {
            localStorage.removeItem("invMonitoring");
            sessionStorage.clear();
            this.isLoggingOut = false;
          },
        });
      sessionStorage.setItem("invUIToken", "");
      sessionStorage.setItem("user", "");
      window.open("#/login", "_self");
    }
    return throwError(errorMessage);
  }
}
